// extracted by mini-css-extract-plugin
module.exports = {"depositItemSectionItemInfoBox":"DepositItemSectionItemInfoBox-Jtails_depositItemSectionItemInfoBox_2F8sM"};